// VersionChip - "v3 ▾" next to a document's name wherever it is listed
// (owner, 2026-09-19): the dropdown lists every version, newest first - rev,
// date, who filed it, size, which is current - and each opens THAT version's
// file in a new tab. The list is read when it opens (GET /doc-control/:id/
// versions): each link carries a short-lived token for this person, so it
// is never stale and never public. Nothing shows for a one-version document.
//
//   <VersionChip docId={doc._id} rev={doc.revisionNumber} count={doc.versionCount} />
//   (leave count out when it is not known: the chip shows and the list tells)
import React, { useState } from "react";
import { Dropdown, Spin } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { url, tokenRef } from "api";

const auth = () => ({ Authorization: `Bearer ${localStorage.getItem(tokenRef)}` });
export const sizeText = (n) => (!n ? "" : n >= 1e6 ? `${(n / 1e6).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1e3))} KB`);
export const dateText = (d) => (d ? new Date(d).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) : "");
export function versionLabel(v) {
  return [`v${v.rev}`, dateText(v.date), v.uploader, sizeText(v.size), v.current ? "current" : ""].filter(Boolean).join(" · ");
}

// count: how many versions the document has; unknown (undefined) still shows
// the chip - the list says - and a known single version shows nothing.
export default function VersionChip({ docId, rev = 0, count, style }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");
  if (!docId || (count !== undefined && !(count > 1))) return null;
  const load = (open) => {
    if (!open) return;
    setItems(null); setError("");
    fetch(`${url}/doc-control/${docId}/versions`, { headers: auth() })
      .then(async (r) => { const b = await r.json().catch(() => ({})); if (!r.ok) throw new Error(b.err || `HTTP ${r.status}`); return b; })
      .then((b) => setItems(b.versions || []))
      .catch((e) => setError(e.message || "Could not read the versions"));
  };
  const menu = error ? [{ key: "e", label: error, disabled: true }]
    : items === null ? [{ key: "l", label: <Spin size="small" />, disabled: true }]
      : items.map((v) => ({ key: String(v.rev), label: versionLabel(v), onClick: () => window.open(`${url}${v.url}`, "_blank", "noopener") }));
  return (
    <Dropdown menu={{ items: menu }} trigger={["click"]} onOpenChange={load}>
      <button type="button" className="bl-version-chip" title={`${count ? `${count} versions` : "Versions"} - pick one to open it in a new tab`} aria-label={`Version ${rev}, show all versions`}
              onClick={(e) => e.stopPropagation()}
              style={{ border: "1px solid #93c5fd", background: "#eff6ff", color: "#1d4ed8", borderRadius: 10, padding: "0 6px", fontSize: 11, lineHeight: "18px", marginLeft: 6, cursor: "pointer", whiteSpace: "nowrap", ...style }}>
        v{rev} <DownOutlined style={{ fontSize: 8 }} />
      </button>
    </Dropdown>
  );
}
